/**************************************************
 * Nombre:       Formulario_Calificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Google, SchoolOutlined} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import {obtenerPorcentajeCalificacion} from "../../CodigoNegocio/Capacitaciones/obtenerPorcentajeCalificacion";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Respuestas_Test from "./Formulario_Respuestas_Test";
import Tarjeta_Contenido_Preguntas from "../Tarjetas/Tarjeta_Contenido_Preguntas";
import Tarjeta_Preguntas_Test from "../Tarjetas/Tarjeta_Preguntas_Test";

const Formulario_Calificaciones = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'calificaciones',
        nombre: 'Detalle de respuesta',
        Formulario: Formulario_Respuestas_Test,
        Tarjeta: Tarjeta_Preguntas_Test
    })
    const [calificaciones, setCalificaciones] = useState({});

    useEffect(() => {

        let cals = props.props.getValues()
        if (cals) {
            setCalificaciones(cals);
        }


    }, [props.props.watch('calificaciones')]);

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >
                <Grid container size={6}>
                    <IngresoFecha nombre={'Fecha de test'} dato={'fecha'} {...props} editable={false}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SchoolOutlined} nombre={'Capacitacion'} dato={'nombreCapacitacion'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography sx={{
                        fontSize: 18,
                        fontWeight: 600
                    }}>{`Calificacion ${obtenerPorcentajeCalificacion(calificaciones)}%`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Respuestas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto editable={false}/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Calificaciones